module.exports = __webpack_public_path__ + "img/logo_zgdx.6c9990f7.png";